<template>
    <div class="button-wrapper flex">
        <button
            @click="$emit('click')"
            :disabled="loading"
            class="flex px-6 py-5 pr-10 rounded-full text-dark-deep-blue bg-white hover:opacity-70 transition w-full"
            :class="[loading ? '!opacity-70' : '']"
        >
            <div class="flex items-center">
                <div class="download-icon text-green pr-4">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M9 12.75l3 3m0 0l3-3m-3 3v-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                </div>
                <div class="file-details text-left">
                    <span class="text-lg font-semibold">
                        {{ loading ? "Loading..." : label }}
                    </span>
                    <span class="block text-sm uppercase" v-if="filename">{{ filename }}</span>
                </div>
            </div>
        </button>
    </div>
</template>

<script>
export default {
    name: "DownloadPillComponent",
    props: {
        label: { type: String, default: "" }, // Sets the label of the button
        filename: { type: String, default: "" },
        loading: { type: Boolean, default: false },
    },
};
</script>
